// extracted by mini-css-extract-plugin
export default {"wholeDiv":"FooterTablet_wholeDiv__DBeKu","Text":"FooterTablet_Text__c2CUd","innerText":"FooterTablet_innerText__8G-du"};